import controller from './input-geo.controller';
import template from './input-geo.html';
import './input-geo.scss';

export default {
	template,
	bindings:     {
		data:       '=ngModel',
		disabled:   '<?ngDisabled',
		options:    '=?',
		projection: '=?',
		required:   '<?ngRequired',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: '?ngModel',
	},
};
